import React, { memo } from 'react';
import { useLocale } from '@react-aria/i18n';
import { date } from '../../utils';
import { useGridState, SelectorCell, Selector } from './selector';
import styles from './styles.module.css';
const COLUMNS = 1;
function useMonthsSelectState({ value, onSelect, isRange }) {
    return useGridState({
        minValue: 1,
        // всего 6 ренжей январь-февраль (1) ... ноябрь-декабрь (6)
        maxValue: isRange ? 6 : 12,
        columns: COLUMNS,
        value,
        onSelect,
    });
}
const MonthCell = memo(function MonthCell({ value, isRange, }) {
    const { locale } = useLocale();
    const format = new date.DateFormatter(locale, { month: 'long' });
    const startValue = isRange
        ? // левый месяц ренжа
            format.format(new Date(Date.UTC(2000, value * 2 - 1 - 1, 1, 0, 0, 0)))
        : format.format(new Date(Date.UTC(2000, value - 1, 1, 0, 0, 0)));
    const endValue = isRange
        ? // правый месяц ренжа
            format.format(new Date(Date.UTC(2000, value * 2 - 1, 1, 0, 0, 0)))
        : startValue;
    return (React.createElement(SelectorCell, { className: styles.monthButton, value: value }, startValue === endValue ? (startValue) : (React.createElement(React.Fragment, null,
        React.createElement("span", null, startValue),
        React.createElement("span", null, " \u2013 "),
        React.createElement("span", null, endValue)))));
});
export function MonthsSelect(props) {
    const state = useMonthsSelectState(props);
    return (React.createElement(Selector, { ...props, columns: COLUMNS, state: state, renderValue: value => React.createElement(MonthCell, { value: value, isRange: props.isRange }) }));
}
